import * as React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { ContentSpacing } from 'elc-base-theme';
import { IArticleObjItem } from '../../interfaces/ISearchInterfaces';
import { classes } from '../../utils/Classes';
import {
    PREDICTIVE_VIEWCONTENT_SEARCH_PARAM,
    STANDARD_VIEWCONTENT_SEARCH_PARAM,
    SEARCH_VIEW,
    SEARCH_TYPE_PARAM,
    SEARCH_PARAM
} from '../../constants/Search';
import { translate, ITranslationsCollection } from 'elc-service';

const ArticleWrapper = styled.div`
    margin-bottom: ${ContentSpacing.space40};
`;

const ImageWrapper = styled.a`
    cursor: pointer;
    margin: 0 auto;
`;

const ArticleImage = styled.img`
    cursor: pointer;
    display: block;
    margin-bottom: ${ContentSpacing.space24};
    max-height: auto;
    width: 100%;
`;

const ArticleTitle = styled.p`
    margin-bottom: ${ContentSpacing.space16};
`;

export interface ISearchArticle {
    article: IArticleObjItem;
    view: number;
    searchTerm?: string;
    translations?: ITranslationsCollection;
}

@translate(['readStory'])
@observer
export class SearchArticle extends React.Component<ISearchArticle> {
    private searchArticleWrapper = classes('search-article-wrapper');
    private searchArticleImageWrapper = classes('search-article-img-wrapper');
    private searchArticleImage = classes('search-article-img');
    private searchArticleTitle = classes('search-article-title');
    private searchArticleLink = classes('search-article-link');
    public render() {
        const {
            article: { templateTitle, uri, urlAlias },
            view,
            searchTerm
        } = this.props;

        const { readStory } = this.props.translations as ITranslationsCollection;

        return (
            <ArticleWrapper className={this.searchArticleWrapper}>
                <ImageWrapper
                    className={this.searchArticleImageWrapper}
                    href={`/${urlAlias}${SEARCH_PARAM}${searchTerm}${SEARCH_TYPE_PARAM}${
                        view === SEARCH_VIEW.OVERLAY_ARTICLES
                            ? PREDICTIVE_VIEWCONTENT_SEARCH_PARAM
                            : STANDARD_VIEWCONTENT_SEARCH_PARAM
                    }`}
                    title={templateTitle}
                    aria-label={templateTitle}
                >
                    <ArticleImage
                        className={this.searchArticleImage}
                        src={uri}
                        alt={templateTitle}
                    />
                </ImageWrapper>
                <ArticleTitle className={this.searchArticleTitle}>{templateTitle}</ArticleTitle>
                <a
                    className={this.searchArticleLink}
                    href={`/${urlAlias}${SEARCH_PARAM}${searchTerm}${SEARCH_TYPE_PARAM}${
                        view === SEARCH_VIEW.OVERLAY_ARTICLES
                            ? PREDICTIVE_VIEWCONTENT_SEARCH_PARAM
                            : STANDARD_VIEWCONTENT_SEARCH_PARAM
                    }`}
                    title={templateTitle}
                    aria-label={templateTitle}
                >
                    {readStory}
                </a>
            </ArticleWrapper>
        );
    }
}
